<script setup>
import { useLayout } from "@/layout/composables/layout";
import { computed } from "vue";

const { layoutConfig } = useLayout();

const logoUrl = computed(() => {
  return `/layout/images/${
    layoutConfig.darkTheme.value ? "logo-white" : "logo-dark"
  }.svg`;
});
</script>

<template>
  <div class="layout-footer">
    <span class="font-medium ml-2"
      >COPYRIGHT INOBERRY INC. ALL RIGHTS RESERVED.</span
    >
  </div>
</template>
<style lang="scss" scoped>
.layout-footer {
  transition: margin-left var(--layout-section-transition-duration);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-top: 1px solid var(--surface-border);
  background-color: var(--surface-card);
  position: sticky; // 또는 fixed
  bottom: 0;
  width: 100%;
  z-index: 1;
}
</style>